import { render, staticRenderFns } from "./sortModal.vue?vue&type=template&id=1e6742ae&scoped=true"
import script from "./sortModal.vue?vue&type=script&lang=js"
export * from "./sortModal.vue?vue&type=script&lang=js"
import style0 from "./sortModal.vue?vue&type=style&index=0&id=1e6742ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6742ae",
  null
  
)

export default component.exports